export default {
  CHANGE_CART: 'CHANGE_CART',
  CHANGE_CART_ERROR: 'CHANGE_CART_ERROR',
  SET_METING_PLACE: 'SET_METING_PLACE',
  GET_CART_TOURS: {
    pending: 'GET_CART_TOURS/pending',
    fulfilled: 'GET_CART_TOURS/fulfilled',
    rejected: 'GET_CART_TOURS/rejected'
  },
  CLEAR_CART: 'CLEAR_CART',
}


// WEBPACK FOOTER //
// ./src/app/containers/Cart/ActionTypes.js